import React from "react";

import UseCasesPageTemplate from "../../components/global/layout/UseCasesPageTemplate";
import { billing } from "../../constants/productPageData";
import { mediaQueries } from "../../constants/mediaQueries";

const Billing = ({ location }) => {
    const imageSettings = [
        {
            id: 1,
            location: "right",
            coloursObj: {
                triangleColour: "#F59E0B",
                backgroundColor: "#FCD34D",
            },
            trianglePosition: "bottom-right",
            axisMultipliers: {
                x: 0.3,
                y: 0.1,
            },
            styles: {
                position: "absolute",
                maxWidth: "1271px",
                right: 120,
                top: 50,

                [mediaQueries.isTabletLandscape]: {
                    right: 40,
                    top: -140,
                }
            },
        }, {
            id: 2,
            location: "left",
            coloursObj: {
                triangleColour: "#6EE7B7",
                backgroundColor: "#10B981",
            },
            trianglePosition: "top-right",
            axisMultipliers: {
                x: 0.1,
                y: 0.4,
            },
        }, {
            id: 3,
            location: "right",
            coloursObj: {
                triangleColour: "#3B82F6",
                backgroundColor: "#1D4ED8",
            },
            trianglePosition: "bottom-left",
            axisMultipliers: {
                x: 0.3,
                y: 0.4,
            },
        }
    ]

    return (
        <UseCasesPageTemplate
            page={billing}
            theme="blue"
            imageSettings={imageSettings}
            location={location}
        />
    )
}

export default Billing